import { Button } from '../ui/button';
import { Undo2, Trash2, Eye, AlertTriangle } from 'lucide-react';

export function AdminDeletedTab({ deletedProviders, onRestore, onPermanentDelete, onViewProvider }) {
  if (deletedProviders.length === 0) {
    return (
      <div className="card-surface p-12 text-center" data-testid="deleted-empty">
        <Trash2 className="h-10 w-10 text-stone-300 mx-auto mb-3" />
        <p className="text-stone-500 font-medium">No deleted providers</p>
        <p className="text-stone-400 text-sm mt-1">Deleted providers will appear here for review</p>
      </div>
    );
  }

  return (
    <div data-testid="deleted-providers-tab">
      <div className="flex items-center gap-2 mb-4">
        <AlertTriangle className="h-4 w-4 text-amber-500" />
        <p className="text-sm text-stone-500">{deletedProviders.length} deleted provider{deletedProviders.length !== 1 ? 's' : ''}, restore or permanently remove</p>
      </div>
      <div className="space-y-3">
        {deletedProviders.map(p => (
          <div key={p.provider_id} className="card-surface p-4 flex items-center gap-4" data-testid={`deleted-provider-${p.provider_id}`}>
            <div className="w-10 h-10 rounded-full bg-red-50 flex items-center justify-center flex-shrink-0">
              <Trash2 className="h-5 w-5 text-red-400" />
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-[#1A1A1A] text-sm">{p.brand_name}</p>
              <p className="text-xs text-stone-400">@{p.username} · {p.user_email} · {p.location || 'No location'}</p>
            </div>
            <div className="flex items-center gap-2 flex-shrink-0">
              <Button
                size="sm" variant="ghost"
                onClick={() => onViewProvider(p)}
                title="View details"
                className="h-8 px-2 text-stone-500"
              >
                <Eye className="h-3.5 w-3.5" />
              </Button>
              <Button
                size="sm"
                onClick={() => onRestore(p.provider_id)}
                className="h-8 px-3 bg-green-600 hover:bg-green-700 text-white text-xs"
                data-testid={`restore-${p.provider_id}`}
              >
                <Undo2 className="h-3.5 w-3.5 mr-1" />
                Restore
              </Button>
              <Button
                size="sm" variant="destructive"
                onClick={() => onPermanentDelete(p.provider_id)}
                className="h-8 px-3 text-xs"
                data-testid={`perm-delete-${p.provider_id}`}
              >
                <Trash2 className="h-3.5 w-3.5 mr-1" />
                Permanent
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
